import { apiProducts } from "./api";

/**
 * @param {*} params
 */

export const sallerCardSelect = async (req) => {
  try {
    const { data } = await apiProducts.get(
      `api/sale-in-progress/table/${req.saleInProgressId}`
    );

    return data;
  } catch (error) {
    console.log("Error in getHourlyReportService ::", error);
    return Promise.reject(`Error in getHourlyReportService :: ${error}`);
  }
};

